// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__3X+BP","content":"styles_content__RLI1l"};